export const isErrorFieldEditable = (params, fieldName) => {
  const { data } = params;
  const { error, errors } = data;
  let response = false;

  if (error) {
    errors.forEach((element) => {
      if (element.field === fieldName) {
        response = true;
      }
    });
  }
  return response;
};

export const getTooltipText = (params, fieldName) => {
  const { data } = params;
  const { error, errors } = data;
  let text = "";

  if (error) {
    errors.forEach((element) => {
      if (element.field === fieldName) {
        text = element.message;
      }
    });
  }

  return text;
};

export const isErrorFieldHighlighted = (params, fieldName) => {
  const { data } = params;
  const { error, errors } = data;
  let cellClass = "";

  if (error) {
    errors.forEach((element) => {
      if (element.field === fieldName) {
        cellClass = "error-cell";
      }
    });
  }

  return cellClass;
};

export const handleCasesEdit = (params, key, setState) => {
  if (
    params.newValue === null ||
    params.newValue === undefined ||
    params.newValue === ""
  ) {
    const { data } = params;
    const { packId } = data;

    setState((prevItems) =>
      prevItems.map((item) =>
        item.packId === packId
          ? {
              ...item,
              [`${key}Cases`]: null,
              [`${key}CasesRounded`]: null,
              [`${key}Pallets`]: null,
              [`${key}PalletsRounded`]: null,
            }
          : item
      )
    );

    return true;
  }

  let rawValue = params.newValue.toString().trim();
  let [integerPart, decimalPart = ""] = rawValue.split(".");
  integerPart = integerPart.replace(/\D/g, "").slice(0, 8);
  decimalPart = decimalPart.replace(/\D/g, "").slice(0, 2);

  let trimmedValue = integerPart || "0";
  if (decimalPart.length) trimmedValue += "." + decimalPart;

  const newValue = Math.ceil(Number(trimmedValue));
  if (isNaN(newValue) || newValue < 0) return false;

  const { data } = params;
  const {
    casesPerLayer,
    layerPerPallet,
    packId,
    orderMultipleQuantity,
    minimumOrderQuantity,
  } = data;

  const totalCasesPerPallet = casesPerLayer * layerPerPallet;

  const pallets = newValue / totalCasesPerPallet;
  const roundedCases =
    newValue <= minimumOrderQuantity
      ? minimumOrderQuantity
      : Math.ceil(newValue / orderMultipleQuantity) * orderMultipleQuantity;
  const roundedPallets = roundedCases / totalCasesPerPallet;

  setState((prevItems) =>
    prevItems.map((item) => {
      if (item.packId === packId) {
        return {
          ...item,
          [`${key}Cases`]:
            newValue === 0 ? null : Math.floor(newValue * 100) / 100,
          [`${key}CasesRounded`]:
            newValue === 0 ? null : Math.round(roundedCases * 100) / 100,
          [`${key}Pallets`]:
            newValue === 0 ? null : Math.floor(pallets * 100) / 100,
          [`${key}PalletsRounded`]:
            newValue === 0 ? null : Math.round(roundedPallets * 100) / 100,
        };
      }
      return item;
    })
  );

  return true;
};

export const handlePalletsEdit = (params, key, setState) => {
  let rawValue = params.newValue ? params.newValue.toString().trim() : "";
  let [integerPart, decimalPart = ""] = rawValue.split(".");
  integerPart = integerPart.replace(/\D/g, "").slice(0, 5);
  decimalPart = decimalPart.replace(/\D/g, "").slice(0, 2);
  let trimmedValue = integerPart || "0";
  if (decimalPart.length) trimmedValue += "." + decimalPart;
  const newValue = Number(trimmedValue);
  if (isNaN(newValue) || newValue < 0) return false;

  const { data } = params;
  const {
    casesPerLayer,
    layerPerPallet,
    packId,
    orderMultipleQuantity,
    minimumOrderQuantity,
  } = data;

  const totalCasesPerPallet = casesPerLayer * layerPerPallet;
  const cases = Math.ceil(newValue * totalCasesPerPallet);
  const roundedCases =
    cases <= minimumOrderQuantity
      ? minimumOrderQuantity
      : Math.ceil(cases / orderMultipleQuantity) * orderMultipleQuantity;
  const roundedPallets = roundedCases / totalCasesPerPallet;

  setState((prevItems) => {
    return prevItems.map((item) => {
      if (item.packId === packId) {
        return {
          ...item,
          [`${key}Pallets`]:
            newValue === 0 ? null : Math.floor(newValue * 100) / 100,
          [`${key}PalletsRounded`]:
            newValue === 0 ? null : Math.round(roundedPallets * 100) / 100,
          [`${key}Cases`]:
            newValue === 0 ? null : Math.floor(cases * 100) / 100,
          [`${key}CasesRounded`]:
            newValue === 0 ? null : Math.round(roundedCases * 100) / 100,
        };
      }

      return item;
    });
  });

  return true;
};

export const handleAmendCasesEdit = (params, setState) => {
  const truncateToTwo = (num) => Math.floor(num * 100) / 100;

  const rawInput = params.newValue?.toString().trim() ?? "";
  let [integerPart, decimalPart = ""] = rawInput.split(".");
  integerPart = integerPart.replace(/\D/g, "").slice(0, 8);
  decimalPart = decimalPart.replace(/\D/g, "").slice(0, 2);

  let trimmedValue = integerPart || "0";
  if (decimalPart.length) {
    trimmedValue += "." + decimalPart;
  }

  const newValue = Math.ceil(Number(trimmedValue));
  if (isNaN(newValue) || newValue < 0) return false;

  const { data } = params;
  const {
    casesPerLayer,
    layerPerPallet,
    packId,
    orderMultipleQuantity,
    minimumOrderQuantity,
  } = data;

  const totalCasesPerPallet = casesPerLayer * layerPerPallet;
  const roundedCases =
    newValue <= minimumOrderQuantity
      ? minimumOrderQuantity
      : Math.ceil(newValue / orderMultipleQuantity) * orderMultipleQuantity;
  const pallets = newValue / totalCasesPerPallet;
  const roundedPallets = roundedCases / totalCasesPerPallet;

  setState((prevItems) =>
    prevItems.map((item) =>
      item.packId === packId
        ? {
            ...item,
            quantityOrdered: newValue === 0 ? null : truncateToTwo(newValue),
            quantityOrderedRounded:
              newValue === 0 ? null : Math.round(roundedCases * 100) / 100,
            palletQuantity: newValue === 0 ? null : truncateToTwo(pallets),
            palletQuantityRounded:
              newValue === 0 ? null : Math.round(roundedPallets * 100) / 100,
          }
        : item
    )
  );

  return true;
};

export const handleAmendPalletsEdit = (params, setState) => {
  const truncateToTwo = (num) => Math.floor(num * 100) / 100;

  const rawValue = params.newValue?.toString().trim() ?? "";
  let [integerPart, decimalPart = ""] = rawValue.split(".");
  integerPart = integerPart.replace(/\D/g, "").slice(0, 5);
  decimalPart = decimalPart.replace(/\D/g, "").slice(0, 2);

  let trimmedValue = integerPart || "0";
  if (decimalPart.length) trimmedValue += "." + decimalPart;

  const newValue = Number(trimmedValue);
  if (isNaN(newValue) || newValue < 0) return false;

  const { data } = params;
  const {
    casesPerLayer,
    layerPerPallet,
    packId,
    orderMultipleQuantity,
    minimumOrderQuantity,
  } = data;

  const totalCasesPerPallet = casesPerLayer * layerPerPallet;
  const cases = Math.ceil(newValue * totalCasesPerPallet);
  const roundedCases =
    cases <= minimumOrderQuantity
      ? minimumOrderQuantity
      : Math.ceil(cases / orderMultipleQuantity) * orderMultipleQuantity;
  const roundedPallets = roundedCases / totalCasesPerPallet;

  setState((prevItems) =>
    prevItems.map((item) =>
      item.packId === packId
        ? {
            ...item,
            palletQuantity: newValue === 0 ? null : truncateToTwo(newValue),
            palletQuantityRounded:
              newValue === 0 ? null : truncateToTwo(roundedPallets),
            quantityOrdered: newValue === 0 ? null : truncateToTwo(cases),
            quantityOrderedRounded:
              newValue === 0 ? null : truncateToTwo(roundedCases),
          }
        : item
    )
  );

  return true;
};
export const calculateTotalCases = (
  index,
  itemsData,
  setTotalCases,
  rounding
) => {
  if (!itemsData || !Array.isArray(itemsData) || index < 0) {
    return 0;
  }

  const poField = rounding
    ? `po${index + 1}CasesRounded`
    : `po${index + 1}Cases`;
  const result = itemsData.reduce((total, item) => {
    const cases = Number(item[poField]) || 0;
    return total + cases;
  }, 0);
  setTotalCases((previous) => ({
    ...previous,
    [index]: result,
  }));
};

export const calculateTotalPallets = (
  index,
  itemsData,
  setTotalPallets,
  rounding
) => {
  if (!itemsData || !Array.isArray(itemsData) || index < 0) {
    return 0;
  }
  const poField = rounding
    ? `po${index + 1}PalletsRounded`
    : `po${index + 1}Pallets`;
  const sum = itemsData.reduce((total, item) => {
    const pallets = Number(item[poField]) || 0;
    return total + pallets;
  }, 0);

  const result = Number(sum.toFixed(2));

  setTotalPallets((previous) => ({
    ...previous,
    [index]: result,
  }));
};

export const calculateTotalBases = (
  index,
  itemsData,
  setTotalBases,
  rounding
) => {
  if (!itemsData || !Array.isArray(itemsData) || index < 0) {
    return 0;
  }
  const poField = `po${index + 1}PalletsRounded`;
  const sum = itemsData.reduce((total, item) => {
    const pallets = Number(item[poField]) || 0;
    return total + pallets;
  }, 0);

  const result = Math.ceil(sum);
  setTotalBases((previous) => ({
    ...previous,
    [index]: result,
  }));
};

export const calculateTotalWagons = (
  index,
  itemsData,
  setTotalWagons,
  palletPerWagon,
  rounding
) => {
  if (!itemsData || !Array.isArray(itemsData) || index < 0) {
    return 0;
  }
  const poField = rounding
    ? `po${index + 1}PalletsRounded`
    : `po${index + 1}Pallets`;
  const sum = itemsData.reduce((total, item) => {
    const pallets = Number(item[poField]) || 0;
    return total + pallets;
  }, 0);

  const result = itemsData.length > 0 ? Math.ceil(sum / palletPerWagon) : 0;

  setTotalWagons((previous) => ({
    ...previous,
    [index]: result,
  }));
};
